import * as angular from "angular";
import { ToastUtils } from "../../helper/toast.helper";

let env = {};
//Import variables if present (from env.js)
if (window) {
    angular.extend(env, window["__env"]);
}

let app = angular.module("resetPassword", [
    "ngResource",
    "ngCookies",
    "credentialsManager",
    "ngSanitize",
    "ngMaterial",
    "theme",
    "sharedTheme",
    "whiteLabelTheme",
    "vcHelper",
]);

app.config(($httpProvider: any) => {
    $httpProvider.defaults.withCredentials = true;
});

// Register environment in AngularJS as constant
app.constant("__env", env);
app.constant("__app_type", "USER");

app.config([
    "$locationProvider",
    ($locationProvider: any) => {
        $locationProvider.hashPrefix("");
    },
]);

app.config(($httpProvider: any) => {
    angular["lowercase"] = (text: string) => (!text ? "" : text.toLowerCase());
    $httpProvider.defaults.withCredentials = true;
});

app.config([
    "$qProvider",
    ($qProvider: any) => {
        $qProvider.errorOnUnhandledRejections(false);
    },
]);

export class ResetPasswordController {
    public url: any;
    public login: any;
    public viewPassword = false;
    public reset_loading = false;
    public link: any;
    public signin: any;
    public error: string | undefined;
    public errorPassword: string | undefined;

    private $scope: any;
    private $http: any;
    private $window: any;
    public __env: any;
    private $timeout: any;
    private apiRoot: string;
    private toast: ToastUtils;
    public loading: boolean = true;
    public linkInvalid: boolean = false;
    public newRequested: boolean = false;

    constructor(
        $scope: any,
        $http: any,
        $window: any,
        $location: any,
        __env: any,
        $timeout: any,
        ToastUtils: ToastUtils
    ) {
        this.apiRoot = __env.apiUrl() + "/user";
        this.$scope = $scope;
        this.$http = $http;
        this.$window = $window;
        this.__env = __env;
        this.$timeout = $timeout;
        this.toast = ToastUtils;

        this.url = $location.search();

        if (this.url.email) {
            this.login = {};
            this.login.uemail = decodeURIComponent(this.url.email);
        }

        this.isValid();
    }

    isValid(): void {
        let details = {
            uid: decodeURIComponent(this.url.uid),
            hash: decodeURIComponent(this.url.hash),
        };

        this.$http
            .post(this.__env.apiUrl() + "/user/reset_password_valid", details)
            .then(
                (response: object) => {
                    if (response["data"].success != true) {
                        this.linkInvalid = true;
                    }
                    this.loading = false;
                },
                () => {
                    this.linkInvalid = true;
                    this.loading = false;
                }
            );
    }

    requestNewResetLink(): void {
        this.newRequested = true;
        this.$http
            .post(this.apiRoot + "/reset_password", {
                uemail: this.login.uemail,
            })
            .then(
                (response: object) => {
                    const json = response["data"];

                    if (json.success) {
                        this.toast.success(
                            "A reset password email has been sent to " +
                                this.login.uemail
                        );
                    } else {
                        this.toast.error();
                    }
                },
                (response: object) => {
                    this.toast.error();
                }
            );
    }

    resetPasswordSubmit(): void {
        this.login.uid = decodeURIComponent(this.url.uid);
        this.login.hash = decodeURIComponent(this.url.hash);
        this.reset_loading = true;
        if (this.login.upassword === this.login.upconfirm) {
            delete this.error;
            delete this.link;
            delete this.errorPassword;
            delete this.signin;

            this.$http
                .post(this.__env.apiUrl() + "/user/update_password", this.login)
                .then((response: object) => {
                    if (response["data"].success == true) {
                        this.toast.success("Your password has been updated");
                        this.signin = "Login";
                        this.$timeout(() => {
                            this.reset_loading = false;
                            this.$window.location = "/signin.php";
                        }, 1000);
                    } else {
                        this.reset_loading = false;
                        if (angular.isDefined(response["data"].link))
                            this.link = "Sign in";
                        this.error = response["data"].message;
                    }
                });
        } else {
            this.reset_loading = false;
            this.errorPassword =
                "The passwords are different, please try again";
        }
    }
}

app.controller("ResetPasswordController", ResetPasswordController);
